import React from 'react';
import Header from '../components/Header';

function CheckoutPage({ onNavigate }) {
  return (
    <div style={{ minHeight: '100vh', background: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px 10px' }}>
		<Header onCartClick={() => { onNavigate(-1); }} onMenuClick={() => { onNavigate('/') }} />
      <div style={{ width: 320, display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 auto', marginTop: 200 }}>
        <div style={{ width: '100%', marginBottom: 32 }}>
          <label style={{ fontWeight: 400, fontSize: 16 }}>Số điện thoại</label>
          <input type="text" placeholder="Nhập số điện thoại" style={inputStyle} />
        </div>
        <button style={btnStyle}>Check-out</button>
      </div>
    </div>
  );
}

const inputStyle = {
  width: '100%',
  height: 44,
  border: '1px solid #5b6754',
  borderRadius: 22,
  padding: '0 16px',
  fontSize: 16,
  marginTop: 4,
  outline: 'none',
  boxSizing: 'border-box',
  fontFamily: 'NeueEinstellung',
};

const btnStyle = {
  width: 180,
  height: 44,
  background: '#5b6754',
  color: '#fff',
  border: 'none',
  borderRadius: 24,
  fontSize: 18,
  fontWeight: 300,
  margin: '12px 0',
  cursor: 'pointer',
  fontFamily: 'NeueEinstellung',
};

export default CheckoutPage;
